<template>
	<div class="sub-detail">
		<div v-if="title" class="sub-detail-title">{{title}}</div>
		<div class="sub-detail-content flex-wrap">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			title: String
		},
		
		data() {
			return {
			}
		}
	}
</script>

<style lang="stylus">
	@import './style/index'
</style>
